import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import L from 'leaflet'
import 'leaflet-groupedlayercontrol';
import 'leaflet.markercluster';
import _ from 'underscore';
import config from './../config';
import helpers from './../utils/helpers';

class MapView extends Component {
	constructor(props) {
		super(props);

		this.mapContainer = React.createRef();
		this.icelandCenter = [64.963051, -19.020836];

		this.placeNameIcon = L.divIcon({
			className: 'placename-icon'
		});

		this.placeNameIconLight = L.divIcon({
			className: 'placename-icon light',
			iconSize: [8, 8],
		});

		this.maxZoom = 13;
		this.minZoom = 7;

		this.markerIcons = this.createIcons();;

		this.ornefniLayerStyle = {
			default: {
				color: "#873700",
				stroke: "#873700",
				weight: 3,
				opacity: 1,
				fillOpacity: 0.8
			},
			selected: {
				color: "#ff0000",
				stroke: "#ff0000",
				weight: 2,
				opacity: 1,
				fillOpacity: 0.8
			}
		};

		window.mapView = this;

		this.maxLmiFeatures = 6000;

		this.markerClusterSettings = {
			maxClusterRadius: 40
		};

		this.state = {
			overlayVisible: props.overlayVisible || false,
			markersMode: 'clusters'
		};
	}

	createIcons(type) {
		let icons = {
			'1': '/img/marker-icon-farm.png',
			'7': '/img/marker-icon-sea.png',
			'3': '/img/marker-icon-mountain.png',
			'10': '/img/marker-icon-mountain.png',
			other: '/img/marker-icon-other.png'
		};

		let ret = {};

		Object.keys(icons).forEach((key) => {
			ret[key] = L.icon({
				iconUrl: icons[key],
				iconAnchor: [16, 16],
				iconSize: [33, 33],
				popupAnchor: [0, -12],
				tooltipAnchor: [12, 0]
			});
		});

		ret['placename'] = L.icon({
			iconUrl: '/img/marker-icon-placename.png',
			iconAnchor: [11, 11],
			iconSize: [23, 23],
			popupAnchor: [0, -8],
			tooltipAnchor: [8, 0]
		});

		return ret;
	}

	componentDidMount() {
		this.layerLmiKort = L.tileLayer.wms('https://gis.lmi.is/mapcache/web-mercator?', {
			layers: 'LMI_Kort',
			format: 'image/png',
			attribution: 'Landmælingar Íslands',
			//crs: 'EPSG:4326',
			transparent: 'true'
		});

		this.layerEggaldin = L.layerGroup([
			L.tileLayer('https://nafnid.is/gis/island-tiles/{z}/{x}/{y}.png', {
				minZoom: this.minZoom,
				maxZoom: this.maxZoom,
				tms: false,
				attribution: 'Trausti Dagsson / Landmælingar Íslands / Náttúrufræðistofnun Íslands'
			}),
			L.tileLayer('https://nafnid.is/gis/island-vegir-tiles/{z}/{x}/{y}.png', {
				minZoom: this.minZoom,
				maxZoom: this.maxZoom,
				tms: false,
				attribution: 'Trausti Dagsson / Landmælingar Íslands / Náttúrufræðistofnun Íslands'
			})
		]);

		this.layerEggaldinAtlas = L.layerGroup([
			L.tileLayer('https://eggald.in/island/atlas/{z}/{x}/{y}.png', {
				minZoom: this.minZoom,
				maxZoom: this.maxZoom,
				tms: false,
				attribution: 'Trausti Dagsson / Landmælingar Íslands / Náttúrufræðistofnun Íslands'
			}),
			L.tileLayer('https://eggald.in/island/vegir-atlas/{z}/{x}/{y}.png', {
				minZoom: this.minZoom,
				maxZoom: this.maxZoom,
				tms: false,
				attribution: 'Trausti Dagsson / Landmælingar Íslands / Náttúrufræðistofnun Íslands'
			})
		]);

		this.layerOpenStreetMap = L.tileLayer('https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
			maxZoom: 19,
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>'
		});

		this.layerLmiEinfalt = L.tileLayer.wms('https://gis.lmi.is/mapcache/web-mercator?', {
			layers: 'LMI_Island_einfalt',
			format: 'image/png',
			attribution: 'Landmælingar Íslands',
			//crs: 'EPSG:4326',
			transparent: 'true'
		});

		this.layerLmiAtlas = L.tileLayer.wms('https://gis.lmi.is/mapcache/web-mercator?', {
			layers: 'LMI_raster:atlas',
			format: 'image/png',
			attribution: 'Landmælingar Íslands',
			//crs: 'EPSG:4326',
			transparent: 'true'
		});

		this.layerLmiSyslur = L.tileLayer.wms('https://gis.lmi.is/geoserver/wms?', {
			layers: 'LMI_vektor:gomlu_syslurnar_byggt_a_korti_1990',
			format: 'image/png',
			attribution: 'Landmælingar Íslands',
			//crs: 'EPSG:4326',
			transparent: 'true'
		});

		this.layerLmiSveitarfelog1904 = L.tileLayer.wms('https://gis.lmi.is/geoserver/wms?', {
			layers: 'LMI_vektor:sveitarfelog_desember_1904',
			format: 'image/png',
			attribution: 'Landmælingar Íslands',
			//crs: 'EPSG:4326',
			transparent: 'true'
		});

		this.layerLmiSveitarfelog1948 = L.tileLayer.wms('https://gis.lmi.is/geoserver/wms?', {
			layers: 'LMI_vektor:sveitarfelog_desember_1948',
			format: 'image/png',
			attribution: 'Landmælingar Íslands',
			//crs: 'EPSG:4326',
			transparent: 'true'
		});

		this.layerLmiSveitarfelog1994 = L.tileLayer.wms('https://gis.lmi.is/geoserver/wms?', {
			layers: 'LMI_vektor:sveitarfelog_desember_1994',
			format: 'image/png',
			attribution: 'Landmælingar Íslands',
			//crs: 'EPSG:4326',
			transparent: 'true'
		});

		this.layerLmiSveitarfelogEmpty = L.layerGroup();

		this.layerLmiOrnefni = L.tileLayer.wms('https://gis.lmi.is/geoserver/wms?', {
			layers: 'Ornefni_an_mannvirkja',
			format: 'image/png',
			attribution: 'Landmælingar Íslands',
			//crs: 'EPSG:4326',
			transparent: 'true'
		});

		let baseLayers = {
			'Kort': this.layerEggaldin,
			'Kort Atlas': this.layerEggaldinAtlas,
			'LMÍ grunnkort': this.layerLmiKort,
			'LMÍ einfalt': this.layerLmiEinfalt,
			'Herforingjaráðskort': this.layerLmiAtlas,
			'Open Street Map': this.layerOpenStreetMap
		};

		let overleyLayers = {
			'': {
				'Örnefni Lmí': this.layerLmiOrnefni
			},
			'<strong>Mörk stjórnsýslueininga</strong>': {
				'Fela': this.layerLmiSveitarfelogEmpty,
				'Sýslumörk': this.layerLmiSyslur,
				'Sveitarfélög 1904': this.layerLmiSveitarfelog1904,
				'Sveitarfélög 1948': this.layerLmiSveitarfelog1948,
				'Sveitarfélög 1994': this.layerLmiSveitarfelog1994
			}
		};

		this.map = L.map(this.mapContainer.current, {
			minZoom: this.minZoom,
			maxZoom: this.maxZoom,
			layers: [this.layerEggaldin]
		}).setView(this.icelandCenter, 6);

		L.control.groupedLayers(baseLayers, overleyLayers, {
			collapsed: false,
			exclusiveGroups: ['<strong>Mörk stjórnsýslueininga</strong>'],
			position: 'bottomleft'
		}).addTo(this.map);

		this.markers = [];

		if (this.props.mapData && this.props.mapData.length > 0) {
			this.addMarkers(this.props.mapData);
		}

		if (this.props.searchParams || this.props.featureData) {
			this.updateGeoServerLayer(this.props.searchParams, this.props.featureData);
		}

		if (this.props.searchParams) {
			this.fetchBaeirData(this.props.searchParams)
		}

		window.mapView = this
	}

	componentDidUpdate(prevProps) {
		if (this.props.viewInTabs && this.props.selectedTab === 'kort' && !this.mapInitialized) {
			this.updateMapSize();

			this.mapInitialized = true;

			if (this.boundsWaiting) {
				try {
					this.map.fitBounds(this.boundsWaiting, {
						maxZoom: 10
					});
				}
				catch(e) {}

				this.boundsWaiting = null;
			}
		}
		else if (this.props.selectedTab !== prevProps.selectedTab) {
			this.updateMapSize();
		}

		if (this.props.mapData && this.props.mapData !== prevProps.mapData) {
			this.addMarkers(this.props.mapData);
		}

		if (this.props.maximized !== prevProps.maximized) {
			this.updateMapSize();
		}

		if ((this.props.searchParams !== prevProps.searchParams) || (this.props.featureData !== prevProps.featureData)) {
			this.updateGeoServerLayer(this.props.searchParams, this.props.featureData);
		}

		if (this.props.searchParams !== prevProps.searchParams) {
			this.fetchBaeirData(this.props.searchParams);
		}
	}

	fetchBaeirData(params) {
		let urlParams = helpers.createUrlParams(params);

		urlParams.push('limit=1000');

		fetch(config.apiRoot+'/geoleit/?'+urlParams.join('&'))
			.then((response) => response.json())
			.then((json) => {
				let mapData = _.compact(json.results.map((item) => {
					if (item.lat && item.lng) {
						return {
							id: item.baer_id || item.id,
							label: item.name+(item.type == 'placename' ? ' ('+item.baer_name+')' : ''),
							district: item.hreppur+', '+item.sysla,
							type: item.type,
							latLng: [item.lat, item.lng],
							tegund: {
								id: item.tegund_id,
								tegund: item.tegund
							},
							ornefnaskra_id: item.ornefnaskra
						}
					}
				}));

				this.addMarkers(mapData);
			});
	}

	createLmiLayer(data) {
		let points;

		let featureGeoJson;
		let pointsGeoJson;

		if (this.state.uuidData) {
			data.features = _.filter(data.features, (item) => _.findWhere(this.state.uuidData, {uuid: item.properties.uuid}));

			points = _.filter(data.features, (item) => item.geometry.type === 'MultiPoint');
			let otherFeatures = _.filter(data.features, (item) => item.geometry.type !== 'MultiPoint');

			featureGeoJson = {
				type: 'FeatureCollection',
				features: _.filter(data.features, (item) => item.geometry.type !== 'MultiPoint')
			};

			pointsGeoJson = {
				type: 'FeatureCollection',
				features: _.filter(data.features, (item) => item.geometry.type === 'MultiPoint')
			};
		}


		let createGeoJsonLayer = (layerData) => L.geoJSON(layerData, {
			style: (feature) => {
				return this.ornefniLayerStyle.default
			},
			pointToLayer: (geoJsonPoint, latlng) => {
				let ornefniItem;

				if (this.state.uuidData) {
					ornefniItem = _.findWhere(this.state.uuidData, {uuid: geoJsonPoint.properties.uuid});
				}

				let marker;

				marker = L.marker(latlng, {
					icon: this.placeNameIcon,
					title: geoJsonPoint.properties.ornefni
				});

				if (ornefniItem) {
					marker.bindPopup(
						'<h4>'+ornefniItem.ornefni+'</h4>'+
						'<a href="/ornefnaskra/'+ornefniItem.ornefnaskra+'">Sjá örnefnaskrá</a></p>'
					);
				}

				return marker;
			},
			onEachFeature: (feature, layer) => {
				layer.bindTooltip(feature.properties.ornefni);

				if (this.state.uuidData) {
					let ornefniItem = _.findWhere(this.state.uuidData, {uuid: feature.properties.uuid});

					if (ornefniItem) {
						layer.bindPopup(
							'<h4>'+ornefniItem.ornefni+'</h4>'+
							'<a href="/ornefni/'+ornefniItem.id+'">Sjá nánar um örnefni</a><br/>'+
							'<a href="/ornefnaskra/'+ornefniItem.ornefnaskra+'">Sjá örnefnaskrá</a>'
						);
					}
				}
			}
		});

		if (this.state.uuidData && points.length > 300) {
			let clusterLayer = L.markerClusterGroup(this.markerClusterSettings);

			clusterLayer.addLayer(createGeoJsonLayer(featureGeoJson))
			clusterLayer.addLayer(createGeoJsonLayer(pointsGeoJson))

			return clusterLayer;
		}
		else {
			return createGeoJsonLayer(data);
		}
	}

	updateGeoServerLayer(searchParams, featureData, highlightId) {
		if (this.geoserverLayer) {
			this.map.removeLayer(this.geoserverLayer);
		}

		if (featureData) {
			this.geoserverLayer = L.layerGroup();

			let chunkSize = 30;

			for (let i = 0; i < featureData.length; i += chunkSize) {
				let chunk = featureData.slice(i, i + chunkSize);

				fetch('https://gis.lmi.is/geoserver/wms?service=WFS&version=1.0.0&request=GetFeature&typeName=ornefni_flakar,ornefni_linur,ornefni_punktar&maxFeatures='+this.maxLmiFeatures+'&outputFormat=application%2Fjson&cql_filter='+encodeURIComponent(chunk.map((feature) => 'uuid = \''+feature+'\'').join(' OR ')))
					.then((res) => res.json())
					.then((json) => {
						this.geoserverLayer.addLayer(this.createLmiLayer(json));

						try {
							this.map.fitBounds(this.geoserverLayer.getLayers()[0].getBounds(), {
								maxZoom: 11
							});
			
						}
						catch (e) {}
					});
			}

			this.geoserverLayer.addTo(this.map)
		}
		else if (searchParams) {
			this.fetchSearchData(searchParams);
		}
	}

	fetchSearchData(params) {
		let urlParams = helpers.createUrlParams(params);

		urlParams.push('limit=5000');

		fetch(config.apiRoot+'/uuid/?'+urlParams.join('&'))
			.then(function(response) {
				return response.json();
			})
			.then(function(uuidJson) {
				this.setState({
					uuidData: uuidJson.results
				}, () => {
					fetch('https://gis.lmi.is/geoserver/wms?service=WFS&version=1.0.0&request=GetFeature&typeName=ornefni_flakar,ornefni_linur,ornefni_punktar&maxFeatures='+this.maxLmiFeatures+'&outputFormat=application%2Fjson&cql_filter='+encodeURIComponent('ornefni ILIKE \''+params.searchString.split('*').join('%')+'\''))
						.then((res) => res.json())
						.then((lmiJson) => {
							this.geoserverLayer = this.createLmiLayer(lmiJson);
							this.geoserverLayer.addTo(this.map);
							window.geoserverLayer = this.geoserverLayer;
						})
				});
			}.bind(this));
	}

	setMarkersMode(mode) {
		this.setState({
			markersMode: mode
		}, () => {
			if (this.props.mapData) {
				this.addMarkers(this.props.mapData);
			}
		})
	}

	addMarkers(data) {
		try {
			this.map.removeLayer(this.markersLayers);
		}
		catch (e) {}

		if (this.state.markersMode == 'clusters') {
			this.markersLayers = L.markerClusterGroup(this.markerClusterSettings).addTo(this.map);
		}
		else {
			this.markersLayers = L.layerGroup(this.markerClusterSettings).addTo(this.map);
		}

		this.markers = [];

		let bounds = [];

		data.map((item) => {
			try {
				let options = {
					title: item.label
				};

				if (item.type === 'placename') {
					options.icon = this.markerIcons['placename'];
				}
				if (item.type === 'farm') {
					options.icon = item.tegund ? this.markerIcons[item.tegund.id] || this.markerIcons['other'] : this.markerIcons['other'];
				}

				if (item.type == 'farm') {
					// todo
				}

				let marker = L.marker(item.latLng, options).bindPopup(
					'<h4>'+item.label+'</h4>'+
					'<p><strong>'+(item.type === 'placename' ? 'Örnefni' : (item.tegund ? item.tegund.tegund : 'Bær'))+'</strong><br/>'+
					(item.district ? item.district+'<br/>' : '')+
					(item.type == 'placename' ? '<a href="/ornefnaskra/'+item.ornefnaskra_id+'">Sjá örnefnaskrá</a></p>' : '<a href="/baer/'+item.id+'">Nánar</a></p>')
				);
				marker.bindTooltip(item.label);

				bounds.push(item.latLng);

				this.markersLayers.addLayer(marker);
				this.markers.push({
					id: item.id,
					type: item.type,
					marker: marker
				});
			}
			catch(e) {
			}
		});

		if (!this.props.viewInTabs || this.props.selectedTab === 'kort') {
			try {
				this.map.fitBounds(bounds, {
					maxZoom: 8
				});
			}
			catch(e) {}
		}
		else {
			if (this.mapInitialized) {
				try {
					this.map.fitBounds(bounds, {
						maxZoom: 8
					});
				}
				catch(e) {}
			}
			else {
				this.boundsWaiting = bounds;
			}
		}

		this.updateMapSize();
	}

	updateMapSize() {
		this.map.invalidateSize();
	}

	highlighLmiVector(uuid) {
		if (this.geoserverLayer) {
			window.geoserverLayer = this.geoserverLayer
			//this.geoserverLayer.setStyle(this.ornefniLayerStyle.default);
			

			let selectedFeature;
			
			_.each(this.geoserverLayer.getLayers(), (layer) => {
				let f = _.find(layer.getLayers(), (l) => l.feature.properties.uuid == uuid)

				if (f) {
					selectedFeature = f;
				}
			});

			if (selectedFeature) {
				this.geoserverLayer.eachLayer(feature => feature.eachLayer(layer => {
					layer.closeTooltip();
					layer.setStyle(this.ornefniLayerStyle.default);
				}));

				selectedFeature.openTooltip();
				selectedFeature.setStyle(this.ornefniLayerStyle.selected);

				//this.geoserverLayer.getLayer(feature._leaflet_id).openTooltip();

				//this.geoserverLayer.getLayer(feature._leaflet_id).setStyle(this.ornefniLayerStyle.selected);
				//this.geoserverLayer.getLayer(feature._leaflet_id).openTooltip();


				if (selectedFeature.getCenter) {
					this.map.fitBounds(selectedFeature.getBounds(), {
						maxZoom: this.maxZoom
					});
				}
				else {
					this.map.fitBounds(selectedFeature.getBounds(), {
						maxZoom: this.maxZoom
					});
				}
			}
		}

		/*return;*/
	}

	highlighMarker(marker) {
		let foundMarker = _.find(this.markers, (item) => {
			return item.id === marker.id && item.type === marker.type
		});

		if (foundMarker) {
			foundMarker.marker.openPopup();
		}
	}

	render() {
		return (
			<div className={'map-wrapper '+(this.props.className || '')}>
				<div ref={this.mapContainer} className={'map-container '} />
				{
					this.props.overlayListData && this.props.overlayListData.length > 1 &&
					<div className={'map-overlay-list'+(this.state.overlayVisible ? ' visible' : '')+(this.state.overlayHover ? ' hover' : '')}>

						<button title="Sýna lista" className="position-button" onMouseOver={() => {
							this.setState({
								overlayHover: true
							})
						}} onMouseOut={() => {
							this.setState({
								overlayHover: false
							})
						}} onClick={() => {
							this.setState({
								overlayVisible: !this.state.overlayVisible
							})
						}} />

						<div className="overlay-content">

							<div className="list-heading">
							</div>

							<div className="list">
								{
									this.props.overlayListData.map((item, index) =>
										<a key={index} href="#" onClick={(event) => {
											event.preventDefault();

											if (item.type === 'lmi_ornefni') {
												this.highlighLmiVector(item.uuid);
											}
											else if (item.type === 'farm') {
												this.highlighMarker(item);
											}
										}}>{item.label}
											{
												item.district &&
												<React.Fragment><br/><small>{item.district}</small></React.Fragment>
											}
										</a>
									)
								}
							</div>
						</div>

					</div>
				}
				{
					this.props.children && <div className="map-toolbar card">
						{
							this.props.children
						}
					</div>
				}
			</div>
		);
	}
}

export default MapView;



// WEBPACK FOOTER //
// ./src/components/MapView.js